import { pantryColors } from '@pantry/ui'
import React from 'react'
import { useRuleCardEdit } from './RuleCardEditContext'

const p = pantryColors

interface RuleNumberInputProps {
  value: number | string
  onChange: (next: string) => void
  unit: string
  min?: number
  step?: number
  error?: string
  disabled?: boolean
}

export const RuleNumberInput: React.FC<RuleNumberInputProps> = ({
  value,
  onChange,
  unit,
  min = 0,
  step = 1,
  error,
  disabled,
}) => {
  const { isEditing } = useRuleCardEdit()
  // When the card is not in edit mode, the input renders as a read-only display
  // value (bold, borderless) per the mockup's `.rule-group:not(.editing)` style.
  const readOnly = !isEditing || disabled

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 4,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <input
          type="number"
          value={value}
          min={min}
          step={step}
          disabled={disabled}
          readOnly={readOnly}
          tabIndex={readOnly ? -1 : undefined}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: 80,
            padding: '6px 10px',
            border: `1px solid ${
              readOnly ? 'transparent' : error ? '#DC2626' : p.gray[200]
            }`,
            borderRadius: 6,
            fontSize: 13,
            fontWeight: readOnly ? 700 : 400,
            textAlign: 'right',
            color: readOnly ? p.gray[800] : p.gray[700],
            background: readOnly ? 'transparent' : p.white,
            pointerEvents: readOnly ? 'none' : 'auto',
            outline: 'none',
          }}
          onFocus={(e) => {
            if (!readOnly && !error) {
              e.currentTarget.style.borderColor = p.brand.primary
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(37,99,235,.1)'
            }
          }}
          onBlur={(e) => {
            if (!readOnly) {
              e.currentTarget.style.borderColor = error
                ? '#DC2626'
                : p.gray[200]
            }
            e.currentTarget.style.boxShadow = 'none'
          }}
        />
        <span
          style={{
            fontSize: 12,
            color: p.gray[400],
            minWidth: 64,
            textAlign: 'left',
          }}
        >
          {unit}
        </span>
      </div>
      {!readOnly && error && (
        <div
          style={{
            fontSize: 11.5,
            color: '#DC2626',
            fontWeight: 500,
            maxWidth: 220,
            textAlign: 'right',
          }}
        >
          {error}
        </div>
      )}
    </div>
  )
}
